
const GetStarted = () => {
  return <div>Get started</div>;
};

export default GetStarted;
